import { createContext } from 'react';

import {
  AgingDashboard,
  AgingFilters,
  AgingMeasure,
} from '@totem/components/ticketing/agingDashboard/types';

export const DEFAULT_FILTERS: AgingFilters = {
  buildingId: [],
  type: [],
  priority: [],
  category: [],
};

export interface FilterOption {
  value: string;
  label: string;
}

interface Context {
  loading: boolean;
  failed: boolean;
  data: AgingDashboard | null;
  filters: AgingFilters;
  setFilters: (update: Partial<AgingFilters>) => void;
  measure: AgingMeasure;
  setMeasure: (measure: AgingMeasure) => void;
  typeOptions: FilterOption[];
  categoryOptions: FilterOption[];
  refresh: () => void;
}

export default createContext<Context>({
  loading: false,
  failed: false,
  data: null,
  filters: DEFAULT_FILTERS,
  setFilters: () => {},
  measure: 'update',
  setMeasure: () => {},
  typeOptions: [],
  categoryOptions: [],
  refresh: () => {},
});
